import styled from "styled-components";

export const NoContent = styled.div`
  text-align: center;
  padding-top: 2.5rem;
`;
